export { default } from "./chart3";


// WEBPACK FOOTER //
// ./src/components/chart3/index.js